export default __webpack_public_path__ + "static/media/hero_card_graph_green@2x.2229f388.png";